




    import {Vue, Component, Prop, Watch, Emit} from 'vue-property-decorator'
import dataProxy from "@/services/data-proxy.service";
import {mixins} from "vue-class-component"
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
    import {PoslovniPartner} from "@/services/BackendProxies";

@Component({})
export default class PoslovniPartneriEditor extends mixins(ComponentBaseMixin) {
    @Prop() value!: string;
    @Prop({default: undefined}) delatnost!: number;
    @Prop({default: false}) invalid!: boolean;

    data = [];
    model = '';

    @Watch('value') onValueChanged(value: string) {
        this.model = value;
    }

    @Watch('model') onModelChanged(value) {
        this.input(value);
    }

    @Emit() input(value) {}

    async created() {
        const poslovniPartneri = await this.loadData(() => dataProxy.vratiPoslovnePartnere())();
        const dobavljaci = poslovniPartneri.filter(x => x.dobavljac == true);
        if (this.delatnost != undefined) {
            const dobavljaciPoDelatnosti = dobavljaci.filter(x => x.delatnost == this.delatnost);
            dobavljaciPoDelatnosti.unshift(PoslovniPartner.fromJS(({id: '', naziv: '...'})));
            this.data = dobavljaciPoDelatnosti.map(x => ({id: x.id, text: x.naziv}));
        } else {
            dobavljaci.unshift(PoslovniPartner.fromJS({id: '', naziv: '...'}));
            this.data = dobavljaci.map(x => ({id: x.id, text: x.naziv}));
        }
        this.model = this.value;
    }


}
